const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab');

sectionTab[0].classList.add('sidebar-menu-container-section-tab--active');

document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';
